<template>
  <div class="main">
    <c-panel title="Pontos" titleIcon="fas fa-map-marker-alt">
      <list></list>
    </c-panel>
  </div>
</template>

<script>
import list from "./list"

export default {
  components: { list }
}
</script>

